const config = {
    api_url: process.env.REACT_APP_API_BASE_URL.trim() + '/' + process.env.REACT_APP_API_VERSION.trim(),
    // Max number of simultaneous media uploads (hosting rate-limits concurrent requests)
    upload_concurrency: 2
};

export default config;